'use client';

import { getAnalytics, isSupported, Analytics } from 'firebase/analytics';

import { isProduction } from '@j-s/helpers';

import { getFirebaseApp } from './config';

let analyticsInstance: Analytics | null = null;

export async function initFirebaseAnalytics(
  hasConsent: boolean,
): Promise<Analytics | null> {
  if (typeof window === 'undefined' || !hasConsent || !isProduction) {
    return null;
  }

  if (analyticsInstance) {
    return analyticsInstance;
  }

  try {
    const supported = await isSupported();

    if (supported) {
      analyticsInstance = getAnalytics(getFirebaseApp());
    }
  } catch (err) {
    console.warn('Failed to initialize Firebase Analytics:', err);
  }

  return analyticsInstance;
}

export function getFirebaseAnalytics(): Analytics | null {
  return analyticsInstance;
}
